(() => {
  const initialized = new WeakSet();
  function initialize(scope) {
    scope.querySelectorAll('[data-pm-kit-awareness-template]').forEach(template => {
      const section = template.closest('.shopify-section');
      if (!section || initialized.has(section)) return;
      initialized.add(section);
      let queued = false;
      function synchronize() {
        queued = false;
        const grid = section.querySelector('#gf-products, [data-productgrid-items], [data-globo-filter-items]');
        if (!grid) return;
        const products = Array.from(grid.children).filter(item => item.matches('.productgrid--item') && !item.hidden && item.style.display !== 'none');
        const existing = Array.from(grid.children).filter(item => item.matches('[data-pm-kit-discovery]'));
        existing.slice(1).forEach(item => item.remove());
        let card = existing[0];
        if (!products.length) {
          if (card) card.remove();
          return;
        }
        const anchor = products[Math.min(4, products.length) - 1];
        if (!card) {
          card = template.content.firstElementChild.cloneNode(true);
          anchor.insertAdjacentElement('afterend', card);
        } else if (anchor.nextElementSibling !== card) {
          anchor.insertAdjacentElement('afterend', card);
        }
      }
      function schedule() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(synchronize);
      }
      const observer = new MutationObserver(schedule);
      observer.observe(section, {childList: true, subtree: true});
      synchronize();
      document.addEventListener('shopify:section:unload', event => {
        if (event.target === section) observer.disconnect();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), {once: true});
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
